import Testimonials from '../HomeComponents/Testimonials';
import '../../styles/HomeComponents/Testimonials.css';
import '../../styles/EduComponents/Testimonials1.css';

const Testimonials1 = ({role = ["academy"]}) => {
  return (
    <div>

      <Testimonials
        heading={
            <>
            What <span className="highlight1">our customers</span> say
       </>
        }
        subheading=''
        role={role}
        showRating={true}
      />
    </div>
  );
};

export default Testimonials1;
